import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { IoMdClose } from "react-icons/io";

export default function SuggestionBox({
  openFeedbackDialog,
  setOpenFeedbackDialog,
}) {
  return (
    <Dialog
      open={openFeedbackDialog}
      PaperProps={{
        style: {
          width: "500px",
          height: "max-content",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle
        style={{
          fontSize: 28,
          fontWeight: 600,
          color: "#000000",
        }}
      >
        Suggestion Box
      </DialogTitle>
      <IoMdClose
        size={30}
        className="dialog-icon"
        onClick={() => setOpenFeedbackDialog(false)}
      />
      <DialogTitle
        style={{
          marginTop: -30,
          fontSize: 16,
          color: "#000000",
        }}
      >
        Got Suggestion? Type it below?
      </DialogTitle>
      <DialogContent>
        <form
          className="dialog-form"
          onSubmit={(e) => {
            e.preventDefault();
            setOpenFeedbackDialog(false);
          }}
        >
          <div>
            <div className="dialog-input-field">
              <label htmlFor="title">Title</label>
              <input type="text" name="title" placeholder="Title" />
            </div>
            <div className="dialog-input-field">
              <label htmlFor="content">Suggestion</label>
              <textarea
                type="text"
                name="content"
                rows={5}
                placeholder="Suggestion"
              />
            </div>
            <button className="dialog-button" type="submit">
              Submit
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
